import { endOfMonth, endOfWeek, startOfMonth, startOfWeek } from 'date-fns';

export function getVisibleMonthRange(month: Date): { startDate: string; endDate: string } {
    const start = startOfWeek(startOfMonth(month));
    const end = endOfWeek(endOfMonth(month));

    return {
        startDate: start.toISOString(),
        endDate: end.toISOString(),
    };
}
